module.exports = __webpack_public_path__ + "img/智能终端解决方案.7b8d9d01.jpg";